module.exports = __webpack_public_path__ + "static/media/header.f3c2d58e.svg";